import { createAPI } from '@common'

export default {
  // 上传资源（新建、修改）
  UploadSitesResourceAdd: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0sftpvsdfBee', 'post', config, vConfig),
  // 资源详情
  getSiteResourceDetail: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0sftpvsdfEfubjm', 'get', config, vConfig),
// 删除资源
  postSiteResourceDelete: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0sftpvsdfEfmfuf', 'post', config, vConfig),
  // 资源下载
  postResourceDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf00tjuft0sftpvsdfEpxompbe', 'post', config),
  // 发布端网站端-查看信息
  getWebParameterConf: (config) => createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0xfcQbsbnfufsDpog', 'get', config),
  // 网站端-参数配置-修改
  postWebParameterConf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0xfcQbsbnfufsDpog', 'post', config)
}
